import React from 'react';
import TemplateWithTitle from 'pages/Template/TemplateWithTitle';

interface Props {
    children: React.ReactNode;
    title: string;
}

function Template({ children, title }: Props): React.ReactElement {
    return (
        <TemplateWithTitle isBackBtn={true} title={title}>
            {children}
        </TemplateWithTitle>
    );
}

export default Template;
